import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TLang } from "../../types/lang";
import { getLang } from "../../helpers/getLang";

type TDropdownItemLang = {
  id: number;
  lang: string;
  abbr: string;
};

interface langState {
  lang: TLang;
  languages: Array<TDropdownItemLang>;
}

const initialState: langState = {
  lang: getLang(),
  languages: [
    { id: 1, lang: "English", abbr: "en" },
    { id: 2, lang: "German", abbr: "ge" },
  ],
};

export const langSlice = createSlice({
  name: "lang",
  initialState,
  reducers: {
    setLang(state, action: PayloadAction<TLang>) {
      state.lang = action.payload;
      localStorage.setItem("lang", action.payload);
    },
  },
});

export const { setLang } = langSlice.actions;
